import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Flex, Text } from '@chakra-ui/react';
import { renderSanitizedHtml, useCustomLocale, useSemanticTypography, useStaticHotelInformation } from '@whitbread-eos/utils';
import { useTranslation } from 'next-i18next';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var HotelContactInformation = () => {
  var _useTranslation = useTranslation(['common']),
    t = _useTranslation.t;
  var _useCustomLocale = useCustomLocale(),
    language = _useCustomLocale.language;
  var _useStaticHotelInform = useStaticHotelInformation(),
    contactDetails = _useStaticHotelInform.contactDetails,
    brand = _useStaticHotelInform.brand,
    isLoading = _useStaticHotelInform.isLoading,
    isError = _useStaticHotelInform.isError,
    error = _useStaticHotelInform.error;
  var getTypographyProps = useSemanticTypography();
  var data = contactDetails === null || contactDetails === void 0 ? void 0 : contactDetails.phone;
  var email = contactDetails === null || contactDetails === void 0 ? void 0 : contactDetails.email;
  if (isLoading) {
    return _jsx(Text, {
      children: t('searchresults.list.hotel.loading')
    });
  }
  if (isError) {
    return _jsx(Text, {
      children: error.message
    });
  }
  if (!data) {
    return null;
  }
  var flexStyles = {
    direction: language === 'de' ? 'column' : {
      base: 'column',
      lg: 'row'
    },
    mt: language === 'de' ? '4' : {
      base: '2',
      sm: '1'
    }
  };
  var boxStyles = {
    maxW: language === 'de' ? 'full' : {
      base: 'full',
      lg: '1053px'
    },
    ml: language === 'de' ? '0' : {
      base: '0'
    },
    mt: language === 'de' ? '0' : {
      base: '0',
      lg: '1'
    }
  };
  return _jsxs(Box, _objectSpread(_objectSpread({
    maxW: "full",
    "data-testid": "hotel-details-contact"
  }, containerStyles), {}, {
    children: [_jsx(Text, _objectSpread(_objectSpread({
      as: "h3"
    }, getTypographyProps(headingContactLegacyTypography, headingContactSemanticTypography)), {}, {
      children: t('contactModule.contactLabel')
    })), _jsx(Text, _objectSpread(_objectSpread({
      mt: 4
    }, getTypographyProps({}, contactBodySemanticTypography)), {}, {
      children: "".concat(t('contactModule.phoneLabel'), " ").concat(data)
    })), brand === 'PID' && email && _jsx(Text, _objectSpread(_objectSpread({
      mt: 1
    }, getTypographyProps({}, contactBodySemanticTypography)), {}, {
      children: "".concat(t('booking.leadGuest.Email'), ": ").concat(email)
    })), _jsx(Flex, _objectSpread(_objectSpread({}, flexStyles), {}, {
      children: _jsx(Box, _objectSpread(_objectSpread(_objectSpread({}, boxStyles), {}, {
        className: "formatLinks"
      }, getTypographyProps({}, contactBodySemanticTypography)), {}, {
        children: renderSanitizedHtml(t('contactModule.Email'))
      }))
    }))]
  }));
};
var contactBodySemanticTypography = {
  textStyle: 'body-m-regular'
};
var headingContactLegacyTypography = {
  fontWeight: 'semibold',
  fontSize: {
    base: 'xl',
    sm: '2xl'
  },
  lineHeight: {
    base: '3',
    sm: '4'
  }
};
var headingContactSemanticTypography = {
  textStyle: {
    base: 'heading-s',
    md: 'heading-m'
  }
};
var containerStyles = {
  mt: {
    base: 'lg',
    sm: '3xl'
  },
  mb: {
    base: 'lg',
    sm: '2xl'
  }
};